<template>
 <div class="user-manager-edit">

    <div class="table">
        <div class="row table-header">
            <div class="column">
              <span>Role</span>
            </div>
            <div class="column">
              <span>Content Brief</span>
            </div>
            <div class="column">
              <span>Reporting</span>
            </div>
            <div class="column">
              <span>Strategy Screens</span>
            </div>
        </div>
        <div v-for="(role, i) in roles" :key="i" class="row">
            <div class="column">
              <span>{{ role.name }}</span>
            </div>
            <div class="column">
              <span>{{ role.contentBriefs }}</span>
            </div>
            <div class="column">
              <span>{{ role.reporting ? 'Yes' : 'No' }}</span>
            </div>
            <div class="column">
              <span>{{ role.strategy ? 'Yes' : 'No' }}</span>
            </div>
        </div>
    </div>
    <div class="create-user__controls controls">
    <button
        class="create-user__button cancel button"
        @click.prevent="$emit('cancel')"
    >
        Close
    </button>
    </div>

 </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

const roles = [
    {
        name: 'Page Contributor',
        contentBriefs: 'Assigned Only',
        reporting: false,
        strategy: false,
    },
    {
        name: 'Project Member',
        contentBriefs: 'All',
        reporting: true,
        strategy: false,
    },
    {
        name: 'Project Strategist',
        contentBriefs: 'All',
        reporting: true,
        strategy: true,
    }
]

export default {
  name: 'PermissionsMatrix',
  async created () {
  },
  destroyed () {
  },
  data () {
    return {
        roles: roles
    }
  },
  computed: {
    
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

    .table {
        display: flex;
        flex-direction: column;
        width: 80%;
        border: 1px solid $rfx-silver;
        border-radius: 4px;
        margin: auto;
    }
    .row {
        display: flex;
        width: 100%;
        // margin-top: 10px;
        // padding: 10px;
    }
    .row:not(:last-child) {
      border-bottom: 1px solid $rfx-silver;
    }
    .table-header {
      font-weight: bold;
    }
    .column {
      width: 25%;
    }
    .column > span {
      padding: 10px;
      line-height: 2em;
    }
    .column:not(:last-child) {
      border-right: 1px solid $rfx-silver;
    }
  .user-manager-edit {
    padding: 25px 40px 0;
    position: relative;

    &__tabs {
      display: flex;
      margin-bottom: -1px;

      &_tab {
        width: 110px;
        padding: 16px 0;
        text-align: center;
        font-size: 14px;
        color: $rfx-light-march;
        background-color: transparent;
        border: 1px solid transparent;
        text-decoration: none;

        &_disabled {
          pointer-events: none;
        }

        &_active {
          background-color: #fff;
          color: $rfx-dark-march;
          font-weight: bold;
          border: 1px solid $rfx-light-steel;
          border-bottom: 1px solid #fff;
        }
      }
    }

    &__update-loader {
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      background-color: white;
      top: 74px;
      opacity: 0.5;
      z-index: 10000;
    }

    &__update-loader-ring {
      margin-top: 200px;
    }

    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border: 1px solid $rfx-light-steel;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
      flex: 1 1;
    }

    &__content-wrapper {
      border: 1px solid $rfx-light-steel;
      background-color: #fff;
    }

    &__cross-button {
      cursor: pointer;
      font-size: 35px;
      position: absolute;
      right: 34px;
      top: 34px;
      transform: rotate(45deg);
    }
  }
.controls {
display: flex;
justify-content: flex-end;
margin-top: 20px;
}

.button {
width: 100px;
height: 40px;
border-radius: 4px;
font-size: 10px;
font-weight: 900;
text-transform: uppercase;
margin-left: 30px;
border: none;
outline: none;
cursor: pointer;

    &.cancel {
        color: $rfx-dark-march;
        background-color: #fff;
    }
}
</style>
